/**
 * @generated SignedSource<<17460d48f2eb6a03fd3e6efec0399edb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type JiraPlanStatus = "ACTIVE" | "ARCHIVED" | "TRASHED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type PlanMenuItem$data = {
  readonly defaultNavigationItem: {
    readonly url?: string | null;
  } | null;
  readonly favouriteValue: {
    readonly isFavourite: boolean | null;
  } | null;
  readonly id: string;
  readonly isReadOnly: boolean | null;
  readonly planId: AGG$Long;
  readonly planStatus: JiraPlanStatus | null;
  readonly scenario: {
    readonly scenarioId: AGG$Long;
  };
  readonly title: string | null;
  readonly " $fragmentType": "PlanMenuItem";
};
export type PlanMenuItem$key = {
  readonly " $data"?: PlanMenuItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"PlanMenuItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "PlanMenuItem",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "planId"
      },
      "action": "THROW"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "isReadOnly"
    },
    {
      "kind": "ScalarField",
      "name": "planStatus"
    },
    {
      "concreteType": "JiraFavouriteValue",
      "kind": "LinkedField",
      "name": "favouriteValue",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isFavourite"
        }
      ]
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraScenario",
        "kind": "LinkedField",
        "name": "scenario",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "scenarioId"
            },
            "action": "THROW"
          }
        ]
      },
      "action": "THROW"
    },
    {
      "kind": "LinkedField",
      "name": "defaultNavigationItem",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "url"
            }
          ],
          "type": "JiraSoftwareBuiltInNavigationItem"
        }
      ]
    }
  ],
  "type": "JiraPlan"
};

(node as any).hash = "17bd68a58ffb8cc75cae9686ba724392";

export default node;
